import * as resolvers from 'app/infrastructure/ui/renderer/resolvers';
import { columnName, tableName } from 'app/area/case/case-data-model';
import { getChildEntities } from 'app/infrastructure/store';

export const entryLogValues = (caseState, uiEngineProps) => ({
  entryLogValues: {
    entryTimeRecordedBy: resolvers.getComponentValues(
      caseState, uiEngineProps, columnName[tableName.involvedPersonEntryLog].entryTimeRecordedBy
    ).valueItem,
    egressTime: resolvers.getComponentValues(
      caseState, uiEngineProps, columnName[tableName.involvedPersonEntryLog].egressTime
    ).value,
    egressTimeRecordedBy: resolvers.getComponentValues(
      caseState, uiEngineProps, columnName[tableName.involvedPersonEntryLog].egressTimeRecordedBy
    ).valueItem
  }
});

/**
 * Provides all entry log rows (siblings of the current row) under the same parent.
 */
export const entryLogValuesAllRows = (caseState, uiEngineProps) => {
  const caseData = resolvers.getCaseData(caseState, uiEngineProps);
  const entityContext = resolvers.getEntityContext(caseState, uiEngineProps);
  const rowPath = entityContext.path;
  const parentPath = rowPath.slice(0, rowPath.length - 1);
  // The entity type is taken from the row's own store key, so siblings are found regardless of its exact name.
  const rowEntityType = Object.keys(rowPath[rowPath.length - 1] || {})[0];

  return {
    entryLogAllRows: rowEntityType ? getChildEntities(caseData, parentPath, rowEntityType) : []
  };
};
